import { CustomerActivityV4Query } from '@anyx/common-graphql';

import { useFormatUnixTimeToRelativeDate } from '../../hooks';
import { resolveCustomerCreatedChannel } from '../../utils';
import { CustomerActivityTimeline } from '../customer-activity-timeline';

export type CustomerActivityV4RecordData = NonNullable<
  CustomerActivityV4Query['CustomerActivitiesV4']
>['records'][number];

export const CustomerActivityV4Record = (activity: CustomerActivityV4RecordData) => {
  const time = useFormatUnixTimeToRelativeDate(activity.timestamp);

  switch (activity.__typename) {
    case 'CustomerCreatedActivityV4':
      return (
        <CustomerActivityTimeline.CustomerCreated
          time={time}
          channel={resolveCustomerCreatedChannel(activity.channel)}
        />
      );
    case 'InfluencerJoinedCampaignActivityV4':
      return (
        <CustomerActivityTimeline.InfluencerJoinedCampaign
          time={time}
          campaignName={activity.campaignName}
          campaignUrl={activity.campaignUrl}
        />
      );
    case 'InfluencerPublishedPostActivityV4':
      return (
        <CustomerActivityTimeline.InfluencerPublishedPost
          time={time}
          campaignName={activity.campaignName}
          campaignUrl={activity.campaignUrl}
        />
      );
    case 'InfluencerSubmittedPostActivityV4':
      return (
        <CustomerActivityTimeline.InfluencerSubmittedPost
          time={time}
          campaignName={activity.campaignName}
          campaignUrl={activity.campaignUrl}
        />
      );
    case 'OptInActivityV4':
      if (activity.optInOperation === 'REQUEST_SENT') {
        return <CustomerActivityTimeline.OptInRequested time={time} channel={activity.chatType} />;
      } else if (activity.optInOperation === 'OPT_IN_ACCEPTED') {
        return <CustomerActivityTimeline.OptInAccepted time={time} channel={activity.chatType} />;
      } else if (activity.optInOperation === 'OPTED_OUT') {
        return <CustomerActivityTimeline.OptedOut time={time} channel={activity.chatType} />;
      }
      return null;
    case 'OrderedActivityV4':
      return (
        <CustomerActivityTimeline.CustomerOrdered
          time={time}
          channel={activity.saleChannel}
          orderId={activity.externalOrderId}
          orderUrl={activity.anyXRelativeUrl ?? undefined}
        />
      );
    case 'ProfileUpdatedActivityV4':
      return <CustomerActivityTimeline.ProfileUpdated time={time} userName={activity.user.name} />;
    default:
      return null;
  }
};
